import { useState } from 'react'
import { CollapsibleSection } from './CollapsibleSection'
import { SensorType } from '@atcreate-inc/sigfox-decoder/dist/common'
import clsx from 'clsx'

interface Props {
  sigfoxId: string
  sensorConfigs: Record<string, any>
  setSensorPort: (port: string) => void
}

export function DeviceSensorSelector({ sigfoxId, sensorConfigs, setSensorPort }: Props) {
  const showC3 = false // TODO: fix this
  const sensors: string[] = Object.values(sensorConfigs).map((config) => config.sensorProductName)

  const [selected, setSelected] = useState(-1)

  const [title] = useState('Sensor Readings: ')

  return (
    <CollapsibleSection title={title} open={true}>
      <table className="w-full">
        <thead>
          <tr>
            <td className="w-1/12">
              <b>Port</b>
            </td>
            <td className="w-2/12">
              <b>Sensor Type</b>
            </td>
          </tr>
        </thead>
        <tbody>
          {Object.keys(sensorConfigs).map((port, index) => {
            // const sensor = showC3 && port === 'C3' ? { sensorType: SensorType.AquaTroll500TemperatureSensor } : null
            const sensor =
              showC3 && port === 'C3' ? { sensorType: SensorType.AquaTroll500TemperatureSensor } : sensorConfigs[port]
            // : device.config.sensors[port] // TODO: fix this

            if (!sensor) return null

            const productName = sensor.sensorProductName

            return (
              <tr
                key={index}
                className={clsx({
                  [tailwind.even]: index % 2 === 0 && index !== selected,
                  [tailwind.odd]: index % 2 !== 0 && index !== selected,
                  [tailwind.selected]: index === selected,
                })}
                onClick={() => {
                  setSelected(index)
                  setSensorPort(port)
                }}
              >
                <td>{port}</td>
                <td>{productName === 'Wind Direction' ? 'Wind Direction (NOT SUPPORTED)' : productName}</td>
              </tr>
            )
          })}
        </tbody>
      </table>
      {sensors.includes(SensorType.VegetronixVH400) && (
        <div className="flex justify-end m-3">
          <button className={tailwind.buttonEnabled} onClick={() => {}}>
            Save
          </button>
        </div>
      )}
    </CollapsibleSection>
  )
}

const tailwind = {
  even: 'h-10 text-black text-l font-regular py-2.5 pl-4 pr-4 w-full border-b bg-[#f9f9f9]',
  odd: 'h-10 text-black text-l font-regular py-2.5 pl-4 pr-4 w-full border-b bg-[#fff]',
  selected: 'h-10 text-black text-l font-regular py-2.5 pl-4 pr-4 w-full border-b bg-blue-200',
  inputText:
    'appearance-none border border-red-500 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none w-[100px] text-center',
  buttonEnabled:
    'bg-blue-500 hover:bg-blue-700 text-white font-bold py-1 px-4 rounded focus:outline-none focus:shadow-outline mb-1',
  buttonDisabled: 'bg-gray-400 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline mb-3',
}
